export { EPlatformType, DevicePlatform } from '@web-store-platforms/types';
